// 应用类型
export const APP_MAP = {
  pgy: '1', // 我和旅行蒲公英云店
  zllx: '2', // 中旅旅行
  zggl: '3', // 中国国旅
  zlyd: '4', // 中旅云店
  nbs: '5', // nbs后台
}

export const begin = 'begin'
export const end = 'end'
export const split = '-'
export const privateKey = 'private'
export const publicKey = 'public'
export const rsaOption = { alg: 'SHA256withRSA' }

export const publicStr =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIam4QMsqgLJfxU2kjatMO/40giG+WoPzwAWRohPId85/Hevj+STLrTUItVBDPNB9CwYmkHUV/hzq7Czqu9D9UtpfPwQdHNXXv/7yMFxGCdo9ALlWwIzRbQy3OAyKtPxQNC3NeoetUtfEwR36PqemS6uJSE1VDkiH3BlALWy9xUQIDAQAB'

export const buttonGoodsText = {
  0: '产品已停用',
  1: '立即购买',
  2: '产品已下架',
}
